import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { PageTransitionWrapper } from './components/PageTransitionWrapper';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { PaymentRequests } from './pages/PaymentRequests';
import { Settings } from './pages/Settings';
import { PayoutSettings } from './pages/PayoutSettings';
import { VirtualTerminal } from './pages/VirtualTerminal';
import { PhysicalTerminals } from './pages/PhysicalTerminals';
import { SoftPosTerminals } from './pages/SoftPosTerminals';
import { Connect } from './pages/Connect';
import { Tutorials } from './pages/Tutorials';
import { TutorialDetail } from './pages/TutorialDetail';
import { Orders } from './pages/Orders';
import { OrderDetail } from './pages/OrderDetail';
import { Shops } from './pages/Shops';
import { ShopDetails } from './pages/ShopDetails';
import { Campaigns } from './pages/Campaigns';
import { CampaignDetails } from './pages/CampaignDetails';
import { CampaignForm } from './pages/CampaignForm';
import { PropertyInformation } from './pages/PropertyInformation';
import { Rooms } from './pages/Rooms';
import { AddRoom } from './pages/AddRoom';
import { EditRoom } from './pages/EditRoom';
import { RoomDetail } from './pages/RoomDetail';
import { Inventory } from './pages/Inventory';
import { Rates } from './pages/Rates';
import { Reservations } from './pages/Reservations';
import { ReservationDetail } from './pages/ReservationDetail';
import { BulkPayments } from './pages/BulkPayments';
import { BulkPaymentDetail } from './pages/BulkPaymentDetail';
import { Invoices } from './pages/Invoices';
import { InvoiceDetail } from './pages/InvoiceDetail';
import { InvoiceForm } from './pages/InvoiceForm';
import { Customers } from './pages/Customers';
import { CustomerDetail } from './pages/CustomerDetail';
import { CustomerForm } from './pages/CustomerForm';
import { Sales } from './pages/Sales';
import { SaleDetail } from './pages/SaleDetail';
import { Balance } from './pages/Balance';
import { BalanceSummary } from './pages/BalanceSummary';
import { BalanceActivity } from './pages/BalanceActivity';
import { Payouts } from './pages/Payouts';
import { Suppliers } from './pages/Suppliers';
import { SupplierDetail } from './pages/SupplierDetail';
import { SupplierForm } from './pages/SupplierForm';
import { Bills } from './pages/Bills';
import { BillDetail } from './pages/BillDetail';
import { BillForm } from './pages/BillForm';
import { BillApprovalWizard } from './pages/BillApprovalWizard';
import { BillFinancingWizard } from './pages/BillFinancingWizard';
import { DisputeDetail } from './pages/DisputeDetail';
import { Disputes } from './pages/Disputes';
import { RefundDetail } from './pages/RefundDetail';
import { Refunds } from './pages/Refunds';
import { ChallengeDispute } from './pages/ChallengeDispute';
import { CustomMetrics } from './pages/CustomMetrics';
import { Nadi } from './pages/Nadi';
import { Reports } from './pages/Reports';
import { CardMonitoringPrograms } from './pages/CardMonitoringPrograms';
import { VampDetail } from './pages/VampDetail';
import { PaymentAnalytics } from './pages/PaymentAnalytics';
import { Notifications } from './pages/Notifications';
import { SupplierSelfService } from './pages/SupplierSelfService';
import { BulkSupplierUpload } from './pages/BulkSupplierUpload';
import { BulkBillUpload } from './pages/BulkBillUpload';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/supplier-onboarding/:id" element={<SupplierSelfService data-id="element-7" />} data-id="element-6" />
        <Route path="/overview" element={<ProtectedRoute data-id="element-9">
              <AppLayout data-id="element-10">
                <PageTransitionWrapper data-id="element-11">
                  <Overview data-id="element-12" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-8" />
        <Route path="/notifications" element={<ProtectedRoute data-id="element-14">
              <AppLayout data-id="element-15">
                <PageTransitionWrapper data-id="element-16">
                  <Notifications data-id="element-17" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-13" />
        <Route path="/payment-requests" element={<ProtectedRoute data-id="element-19">
              <AppLayout data-id="element-20">
                <PageTransitionWrapper data-id="element-21">
                  <PaymentRequests data-id="element-22" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-18" />
        <Route path="/bulk-payments" element={<ProtectedRoute data-id="element-24">
              <AppLayout data-id="element-25">
                <PageTransitionWrapper data-id="element-26">
                  <BulkPayments data-id="element-27" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-23" />
        <Route path="/bulk-payment-detail/:id" element={<ProtectedRoute data-id="element-29">
              <AppLayout data-id="element-30">
                <PageTransitionWrapper data-id="element-31">
                  <BulkPaymentDetail data-id="element-32" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-28" />
        <Route path="/settings" element={<ProtectedRoute data-id="element-34">
              <AppLayout data-id="element-35">
                <PageTransitionWrapper data-id="element-36">
                  <Settings data-id="element-37" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-33" />
        <Route path="/settings/payouts" element={<ProtectedRoute data-id="element-39">
              <AppLayout data-id="element-40">
                <PageTransitionWrapper data-id="element-41">
                  <PayoutSettings data-id="element-42" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-38" />
        <Route path="/virtual-terminal" element={<ProtectedRoute data-id="element-44">
              <AppLayout data-id="element-45">
                <PageTransitionWrapper data-id="element-46">
                  <VirtualTerminal data-id="element-47" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-43" />
        <Route path="/physical-terminals" element={<ProtectedRoute data-id="element-49">
              <AppLayout data-id="element-50">
                <PageTransitionWrapper data-id="element-51">
                  <PhysicalTerminals data-id="element-52" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-48" />
        <Route path="/softpos-terminals" element={<ProtectedRoute data-id="element-54">
              <AppLayout data-id="element-55">
                <PageTransitionWrapper data-id="element-56">
                  <SoftPosTerminals data-id="element-57" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-53" />
        <Route path="/connect" element={<ProtectedRoute data-id="element-59">
              <AppLayout data-id="element-60">
                <PageTransitionWrapper data-id="element-61">
                  <Connect data-id="element-62" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-58" />
        <Route path="/tutorials" element={<ProtectedRoute data-id="element-64">
              <AppLayout data-id="element-65">
                <PageTransitionWrapper data-id="element-66">
                  <Tutorials data-id="element-67" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-63" />
        <Route path="/tutorial/:id" element={<ProtectedRoute data-id="element-69">
              <AppLayout data-id="element-70">
                <PageTransitionWrapper data-id="element-71">
                  <TutorialDetail data-id="element-72" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-68" />
        <Route path="/orders" element={<ProtectedRoute data-id="element-74">
              <AppLayout data-id="element-75">
                <PageTransitionWrapper data-id="element-76">
                  <Orders data-id="element-77" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-73" />
        <Route path="/order-detail/:id" element={<ProtectedRoute data-id="element-79">
              <AppLayout data-id="element-80">
                <PageTransitionWrapper data-id="element-81">
                  <OrderDetail data-id="element-82" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-78" />
        <Route path="/shops" element={<ProtectedRoute data-id="element-84">
              <AppLayout data-id="element-85">
                <PageTransitionWrapper data-id="element-86">
                  <Shops data-id="element-87" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-83" />
        <Route path="/shop-details" element={<ProtectedRoute data-id="element-89">
              <AppLayout data-id="element-90">
                <PageTransitionWrapper data-id="element-91">
                  <ShopDetails data-id="element-92" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-88" />
        <Route path="/campaigns" element={<ProtectedRoute data-id="element-94">
              <AppLayout data-id="element-95">
                <PageTransitionWrapper data-id="element-96">
                  <Campaigns data-id="element-97" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-93" />
        <Route path="/campaign-details" element={<ProtectedRoute data-id="element-99">
              <AppLayout data-id="element-100">
                <PageTransitionWrapper data-id="element-101">
                  <CampaignDetails data-id="element-102" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-98" />
        <Route path="/campaign-form" element={<ProtectedRoute data-id="element-104">
              <AppLayout data-id="element-105">
                <PageTransitionWrapper data-id="element-106">
                  <CampaignForm data-id="element-107" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-103" />
        <Route path="/property-information" element={<ProtectedRoute data-id="element-109">
              <AppLayout data-id="element-110">
                <PageTransitionWrapper data-id="element-111">
                  <PropertyInformation data-id="element-112" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-108" />
        <Route path="/rooms" element={<ProtectedRoute data-id="element-114">
              <AppLayout data-id="element-115">
                <PageTransitionWrapper data-id="element-116">
                  <Rooms data-id="element-117" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-113" />
        <Route path="/add-room" element={<ProtectedRoute data-id="element-119">
              <AppLayout data-id="element-120">
                <PageTransitionWrapper data-id="element-121">
                  <AddRoom data-id="element-122" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-118" />
        <Route path="/edit-room" element={<ProtectedRoute data-id="element-124">
              <AppLayout data-id="element-125">
                <PageTransitionWrapper data-id="element-126">
                  <EditRoom data-id="element-127" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-123" />
        <Route path="/room-detail" element={<ProtectedRoute data-id="element-129">
              <AppLayout data-id="element-130">
                <PageTransitionWrapper data-id="element-131">
                  <RoomDetail data-id="element-132" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-128" />
        <Route path="/inventory" element={<ProtectedRoute data-id="element-134">
              <AppLayout data-id="element-135">
                <PageTransitionWrapper data-id="element-136">
                  <Inventory data-id="element-137" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-133" />
        <Route path="/rates" element={<ProtectedRoute data-id="element-139">
              <AppLayout data-id="element-140">
                <PageTransitionWrapper data-id="element-141">
                  <Rates data-id="element-142" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-138" />
        <Route path="/reservations" element={<ProtectedRoute data-id="element-144">
              <AppLayout data-id="element-145">
                <PageTransitionWrapper data-id="element-146">
                  <Reservations data-id="element-147" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-143" />
        <Route path="/reservation-detail" element={<ProtectedRoute data-id="element-149">
              <AppLayout data-id="element-150">
                <PageTransitionWrapper data-id="element-151">
                  <ReservationDetail data-id="element-152" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-148" />
        <Route path="/invoices" element={<ProtectedRoute data-id="element-154">
              <AppLayout data-id="element-155">
                <PageTransitionWrapper data-id="element-156">
                  <Invoices data-id="element-157" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-153" />
        <Route path="/invoice-detail/:id" element={<ProtectedRoute data-id="element-159">
              <AppLayout data-id="element-160">
                <PageTransitionWrapper data-id="element-161">
                  <InvoiceDetail data-id="element-162" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-158" />
        <Route path="/invoice-form" element={<ProtectedRoute data-id="element-164">
              <AppLayout data-id="element-165">
                <PageTransitionWrapper data-id="element-166">
                  <InvoiceForm data-id="element-167" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-163" />
        <Route path="/customers" element={<ProtectedRoute data-id="element-169">
              <AppLayout data-id="element-170">
                <PageTransitionWrapper data-id="element-171">
                  <Customers data-id="element-172" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-168" />
        <Route path="/customer-detail/:id" element={<ProtectedRoute data-id="element-174">
              <AppLayout data-id="element-175">
                <PageTransitionWrapper data-id="element-176">
                  <CustomerDetail data-id="element-177" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-173" />
        <Route path="/customer-form" element={<ProtectedRoute data-id="element-179">
              <AppLayout data-id="element-180">
                <PageTransitionWrapper data-id="element-181">
                  <CustomerForm data-id="element-182" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-178" />
        <Route path="/sales" element={<ProtectedRoute data-id="element-184">
              <AppLayout data-id="element-185">
                <PageTransitionWrapper data-id="element-186">
                  <Sales data-id="element-187" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-183" />
        <Route path="/sale-detail/:id" element={<ProtectedRoute data-id="element-189">
              <AppLayout data-id="element-190">
                <PageTransitionWrapper data-id="element-191">
                  <SaleDetail data-id="element-192" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-188" />
        <Route path="/balance" element={<ProtectedRoute data-id="element-194">
              <AppLayout data-id="element-195">
                <PageTransitionWrapper data-id="element-196">
                  <BalanceSummary data-id="element-197" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-193" />
        <Route path="/balance-activity" element={<ProtectedRoute data-id="element-199">
              <AppLayout data-id="element-200">
                <PageTransitionWrapper data-id="element-201">
                  <BalanceActivity data-id="element-202" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-198" />
        <Route path="/payouts" element={<ProtectedRoute data-id="element-204">
              <AppLayout data-id="element-205">
                <PageTransitionWrapper data-id="element-206">
                  <Payouts data-id="element-207" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-203" />

        <Route path="/suppliers" element={<ProtectedRoute data-id="element-209">
              <AppLayout data-id="element-210">
                <PageTransitionWrapper data-id="element-211">
                  <Suppliers data-id="element-212" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-208" />
        <Route path="/supplier-detail/:id" element={<ProtectedRoute data-id="element-214">
              <AppLayout data-id="element-215">
                <PageTransitionWrapper data-id="element-216">
                  <SupplierDetail data-id="element-217" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-213" />
        <Route path="/supplier-form" element={<ProtectedRoute data-id="element-219">
              <AppLayout data-id="element-220">
                <PageTransitionWrapper data-id="element-221">
                  <SupplierForm data-id="element-222" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-218" />
        <Route path="/supplier-bulk-upload" element={<ProtectedRoute data-id="element-224">
              <AppLayout data-id="element-225">
                <PageTransitionWrapper data-id="element-226">
                  <BulkSupplierUpload data-id="element-227" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-223" />
        <Route path="/bill-bulk-upload" element={<ProtectedRoute data-id="element-229">
              <AppLayout data-id="element-230">
                <PageTransitionWrapper data-id="element-231">
                  <BulkBillUpload data-id="element-232" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-228" />
        <Route path="/bills" element={<ProtectedRoute data-id="element-234">
              <AppLayout data-id="element-235">
                <PageTransitionWrapper data-id="element-236">
                  <Bills data-id="element-237" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-233" />
        <Route path="/bill-detail/:id" element={<ProtectedRoute data-id="element-239">
              <AppLayout data-id="element-240">
                <PageTransitionWrapper data-id="element-241">
                  <BillDetail data-id="element-242" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-238" />
        <Route path="/bill-form" element={<ProtectedRoute data-id="element-244">
              <AppLayout data-id="element-245">
                <PageTransitionWrapper data-id="element-246">
                  <BillForm data-id="element-247" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-243" />
        <Route path="/bill-approval/:id" element={<ProtectedRoute data-id="element-249">
              <AppLayout data-id="element-250">
                <PageTransitionWrapper data-id="element-251">
                  <BillApprovalWizard data-id="element-252" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-248" />
        <Route path="/bill-financing/:id" element={<ProtectedRoute data-id="element-254">
              <AppLayout data-id="element-255">
                <PageTransitionWrapper data-id="element-256">
                  <BillFinancingWizard data-id="element-257" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-253" />
        <Route path="/disputes" element={<ProtectedRoute data-id="element-259">
              <AppLayout data-id="element-260">
                <PageTransitionWrapper data-id="element-261">
                  <Disputes data-id="element-262" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-258" />
        <Route path="/dispute-detail/:id" element={<ProtectedRoute data-id="element-264">
              <AppLayout data-id="element-265">
                <PageTransitionWrapper data-id="element-266">
                  <DisputeDetail data-id="element-267" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-263" />
        <Route path="/disputes/:id" element={<ProtectedRoute data-id="element-269">
              <AppLayout data-id="element-270">
                <PageTransitionWrapper data-id="element-271">
                  <DisputeDetail data-id="element-272" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-268" />
        <Route path="/disputes/:id/challenge" element={<ProtectedRoute data-id="element-274">
              <ChallengeDispute data-id="element-275" />
            </ProtectedRoute>} data-id="element-273" />
        <Route path="/refunds" element={<ProtectedRoute data-id="element-277">
              <AppLayout data-id="element-278">
                <PageTransitionWrapper data-id="element-279">
                  <Refunds data-id="element-280" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-276" />
        <Route path="/refund-detail/:id" element={<ProtectedRoute data-id="element-282">
              <AppLayout data-id="element-283">
                <PageTransitionWrapper data-id="element-284">
                  <RefundDetail data-id="element-285" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-281" />
        <Route path="/custom-metrics" element={<ProtectedRoute data-id="element-287">
              <AppLayout data-id="element-288">
                <PageTransitionWrapper data-id="element-289">
                  <CustomMetrics data-id="element-290" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-286" />
        <Route path="/nadi" element={<ProtectedRoute data-id="element-292">
              <AppLayout data-id="element-293">
                <PageTransitionWrapper data-id="element-294">
                  <Nadi data-id="element-295" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-291" />
        <Route path="/reports" element={<ProtectedRoute data-id="element-297">
              <AppLayout data-id="element-298">
                <PageTransitionWrapper data-id="element-299">
                  <Reports data-id="element-300" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-296" />
        <Route path="/card-monitoring" element={<ProtectedRoute data-id="element-302">
              <AppLayout data-id="element-303">
                <PageTransitionWrapper data-id="element-304">
                  <CardMonitoringPrograms data-id="element-305" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-301" />
        <Route path="/card-monitoring/vamp" element={<ProtectedRoute data-id="element-307">
              <AppLayout data-id="element-308">
                <PageTransitionWrapper data-id="element-309">
                  <VampDetail data-id="element-310" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-306" />
        <Route path="/payment-analytics" element={<ProtectedRoute data-id="element-312">
              <AppLayout data-id="element-313">
                <PageTransitionWrapper data-id="element-314">
                  <PaymentAnalytics data-id="element-315" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-311" />
      </Routes>
    </BrowserRouter>;
}